import { UpdateReferenceImageTriggerProps } from 'screens/Schedule/PostPromptsSection/Types'
import { ReferenceImageTrigger } from 'screens/Schedule/PostPromptsSection/ReferenceImageTrigger'
import { useUpdateReferenceImage } from 'hooks/queries/schedules/contents/useUpdateReferenceImage'

export const UpdateReferenceImageTrigger = ({
  children,
  scheduleId,
  contentId,
  isDisabled,
  ...props
}: UpdateReferenceImageTriggerProps) => {
  const { mutate: updateReferenceImage, isLoading } = useUpdateReferenceImage(
    {
      scheduleId,
      contentId,
    },
    {
      mutationKey: ['referenceImageUpdate', scheduleId, contentId],
    },
  )

  return (
    <ReferenceImageTrigger
      {...props}
      isDisabled={isDisabled || isLoading}
      onUse={(mediaFile) =>
        updateReferenceImage({
          media_file: mediaFile,
        })
      }
    >
      {children}
    </ReferenceImageTrigger>
  )
}
